import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { IconCarOff } from '@tabler/icons-react';
import { useEffect } from 'react';
import { NapakaApi, sporocilo } from '../api/napaka';
import { barve } from '../tema';
import { prepreciIndeksiranje } from './javno';

/**
 * Ponudba ne obstaja (napačna povezava, izklopljena; iskalniki je ne indeksirajo) ali je strežnik nedosegljiv (s
 * »Poskusi znova«).
 */
export function NiPonudbe({ napaka, ponovi }: { napaka: unknown; ponovi: () => void }) {
  const ni = napaka instanceof NapakaApi && napaka.status === 404;
  useEffect(() => (ni ? prepreciIndeksiranje() : undefined), [ni]);
  return (
    <Center mih="100dvh" p="md" bg={barve.ozadjeStrani}>
      <Stack align="center" gap="sm" maw={420} ta="center">
        <IconCarOff size={56} stroke={1.3} color={barve.besediloSekundarno} />
        <Title order={1} size="h3">
          {ni ? 'Ponudba ni na voljo' : 'Ponudbe ni bilo mogoče naložiti'}
        </Title>
        <Text c="dimmed">
          {ni ? 'Povezava je napačna ali prodajalec vozil trenutno ne objavlja na spletu.' : sporocilo(napaka)}
        </Text>
        {!ni && (
          <Button variant="light" onClick={ponovi}>
            Poskusi znova
          </Button>
        )}
      </Stack>
    </Center>
  );
}
